import { Backdrop, CircularProgress, Typography } from '@mui/material';

import { useLoadingStore } from '../stores/useLoadingStore';

export default function Loading() {
    
    const loading = useLoadingStore(state => state.loading);

    const loadingBackdrop = useLoadingStore(state => state.loadingBackdrop);

    const loadingTxt = useLoadingStore(state => state.loadingTxt);

    return (
        <Backdrop
            sx={{
                zIndex: (theme) =>
                theme.zIndex.drawer + 9999,

                flexDirection: 'column',
                display: 'flex',
                gap: 2,

                backgroundColor: (theme) =>
                theme.palette.background.backdrop,

                color: 'text.primary'
            }}
            open={loading || loadingBackdrop}
        >

            <CircularProgress sx={{ color: 'inherit' }}/>

            {loadingTxt && (
                <Typography
                    variant="subtitle1"
                    sx={{
                        mt: 1,
                        textAlign: 'center',
                        fontWeight: 'bold',
                        whiteSpace: 'pre-line',
                        color: 'inherit'
                    }}
                >
                    {loadingTxt}
                </Typography>
            )}

        </Backdrop>
    );
}